const INK = "#1A1918";
const YELLOW = "#FFD026";
const CREAM = "#FAF7EE";

export const LogoMark = ({ className = "h-10 w-10" }) => (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
        <circle cx="32" cy="36" r="23" fill={YELLOW} stroke={INK} strokeWidth="3.5" />
        <path d="M10 32 C10 14 54 14 54 32" fill="none" stroke={INK} strokeWidth="4.5" strokeLinecap="round" />
        <rect x="5" y="28" width="9" height="15" rx="4.5" fill={INK} />
        <rect x="50" y="28" width="9" height="15" rx="4.5" fill={INK} />
        <circle cx="24" cy="34" r="3.2" fill={INK} />
        <circle cx="40" cy="34" r="3.2" fill={INK} />
        <path d="M22 44 C26 50 38 50 42 44" fill="none" stroke={INK} strokeWidth="3.5" strokeLinecap="round" />
    </svg>
);

export const SmileyDoodle = ({ className = "h-12 w-12", fill = YELLOW }) => (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
        <path
            d="M32 7 C47 5 58 17 57 33 C56 49 44 58 30 57 C16 56 6 46 7 31 C8 16 19 9 32 7 Z"
            fill={fill}
            stroke={INK}
            strokeWidth="3.5"
            strokeLinecap="round"
        />
        <circle cx="24" cy="27" r="3" fill={INK} />
        <circle cx="41" cy="26" r="3" fill={INK} />
        <path d="M21 39 C26 47 39 47 44 38" fill="none" stroke={INK} strokeWidth="3.5" strokeLinecap="round" />
    </svg>
);

export const StarDoodle = ({ className = "h-5 w-5", fill = INK }) => (
    <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
        <path
            d="M12 1.5 L14.4 8.6 L22 11 L14.9 13.6 L12.5 21 L9.7 13.9 L2 11.5 L9.3 8.9 Z"
            fill={fill}
            stroke={INK}
            strokeWidth="1.4"
            strokeLinejoin="round"
        />
    </svg>
);

export const ScribbleArrow = ({ className = "h-10 w-16" }) => (
    <svg viewBox="0 0 80 48" className={className} aria-hidden="true">
        <path
            d="M6 8 C24 4 52 6 62 22 C66 29 62 38 52 40"
            fill="none"
            stroke={INK}
            strokeWidth="3"
            strokeLinecap="round"
            strokeDasharray="1 0"
        />
        <path d="M60 32 L53 41 L47 33" fill="none" stroke={INK} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const Squiggle = ({ className = "h-3 w-28", stroke = "#FF70A6" }) => (
    <svg viewBox="0 0 120 12" className={className} aria-hidden="true" preserveAspectRatio="none">
        <path
            d="M2 8 C12 2 22 10 32 6 C42 2 52 10 62 6 C72 2 82 10 92 6 C102 2 112 9 118 6"
            fill="none"
            stroke={stroke}
            strokeWidth="4"
            strokeLinecap="round"
        />
    </svg>
);

const Spool = ({ cx, cy, spinning }) => (
    <g className={spinning ? "spool-spin" : undefined}>
        <circle cx={cx} cy={cy} r="17" fill={CREAM} stroke={INK} strokeWidth="4" />
        {[0, 60, 120].map((deg) => (
            <line
                key={deg}
                x1={cx - 12}
                y1={cy}
                x2={cx + 12}
                y2={cy}
                stroke={INK}
                strokeWidth="4"
                strokeLinecap="round"
                transform={`rotate(${deg} ${cx} ${cy})`}
            />
        ))}
        <circle cx={cx} cy={cy} r="4" fill={INK} />
    </g>
);

export const CassetteTape = ({ className = "w-full", spinning = false }) => (
    <svg viewBox="0 0 320 210" className={className} fill="none" aria-hidden="true">
        <rect x="6" y="6" width="308" height="198" rx="18" fill="#23201D" stroke={INK} strokeWidth="5" />
        <rect x="28" y="24" width="264" height="104" rx="10" fill={CREAM} stroke={INK} strokeWidth="4" />
        <text x="160" y="46" textAnchor="middle" fontFamily="'Space Mono', monospace" fontSize="13" fontWeight="700" fill={INK} letterSpacing="2">
            SIDE A · HEAT VOL. 1
        </text>
        <rect x="56" y="56" width="208" height="58" rx="8" fill={YELLOW} stroke={INK} strokeWidth="4" />
        <line x1="108" y1="85" x2="212" y2="85" stroke={INK} strokeWidth="3" strokeLinecap="round" opacity="0.5" />
        <Spool cx={104} cy={85} spinning={spinning} />
        <Spool cx={216} cy={85} spinning={spinning} />
        <path d="M92 204 L104 150 L216 150 L228 204" fill="#3A3734" stroke={INK} strokeWidth="4" strokeLinejoin="round" />
        <circle cx="160" cy="176" r="9" fill={CREAM} stroke={INK} strokeWidth="3.5" />
        <circle cx="24" cy="22" r="4" fill={CREAM} opacity="0.7" />
        <circle cx="296" cy="22" r="4" fill={CREAM} opacity="0.7" />
        <circle cx="24" cy="188" r="4" fill={CREAM} opacity="0.7" />
        <circle cx="296" cy="188" r="4" fill={CREAM} opacity="0.7" />
    </svg>
);

export const VinylRecord = ({ className = "h-40 w-40", spinning = true }) => (
    <svg viewBox="0 0 200 200" className={className} aria-hidden="true">
        <circle cx="100" cy="100" r="96" fill={INK} />
        <g className={spinning ? "spool-spin" : undefined}>
            {[82, 70, 58].map((r) => (
                <circle key={r} cx="100" cy="100" r={r} fill="none" stroke="#3A3734" strokeWidth="2" />
            ))}
            <path d="M100 12 A88 88 0 0 1 178 72" fill="none" stroke="#4A4642" strokeWidth="5" strokeLinecap="round" />
            <circle cx="100" cy="100" r="36" fill={YELLOW} stroke={CREAM} strokeWidth="2.5" />
            <circle cx="88" cy="94" r="3.4" fill={INK} />
            <circle cx="112" cy="94" r="3.4" fill={INK} />
            <path d="M87 106 C92 113 108 113 113 106" fill="none" stroke={INK} strokeWidth="3.4" strokeLinecap="round" />
            <circle cx="100" cy="100" r="4" fill={CREAM} />
        </g>
    </svg>
);

export const MicrophoneDoodle = ({ className = "h-24 w-24" }) => (
    <svg viewBox="0 0 120 140" className={className} fill="none" aria-hidden="true">
        <rect x="38" y="8" width="44" height="72" rx="22" fill="#FF70A6" stroke={INK} strokeWidth="4" />
        <line x1="42" y1="30" x2="78" y2="30" stroke={INK} strokeWidth="3.5" strokeLinecap="round" />
        <line x1="42" y1="44" x2="78" y2="44" stroke={INK} strokeWidth="3.5" strokeLinecap="round" />
        <line x1="42" y1="58" x2="78" y2="58" stroke={INK} strokeWidth="3.5" strokeLinecap="round" />
        <path d="M26 56 C26 84 94 84 94 56" stroke={INK} strokeWidth="4" strokeLinecap="round" />
        <line x1="60" y1="86" x2="60" y2="116" stroke={INK} strokeWidth="4" strokeLinecap="round" />
        <line x1="38" y1="118" x2="82" y2="118" stroke={INK} strokeWidth="5" strokeLinecap="round" />
        <path d="M16 30 C10 40 10 50 14 60" stroke={INK} strokeWidth="3.5" strokeLinecap="round" />
        <path d="M104 30 C110 40 110 50 106 60" stroke={INK} strokeWidth="3.5" strokeLinecap="round" />
    </svg>
);

export const HeadphonesDoodle = ({ className = "h-24 w-24" }) => (
    <svg viewBox="0 0 140 120" className={className} fill="none" aria-hidden="true">
        <path d="M24 92 C24 30 116 30 116 92" stroke={INK} strokeWidth="6" strokeLinecap="round" />
        <rect x="12" y="78" width="26" height="36" rx="11" fill="#3FA9F5" stroke={INK} strokeWidth="4" />
        <rect x="102" y="78" width="26" height="36" rx="11" fill="#3FA9F5" stroke={INK} strokeWidth="4" />
        <path d="M4 88 C1 94 1 100 4 106" stroke={INK} strokeWidth="3" strokeLinecap="round" />
        <path d="M136 88 C139 94 139 100 136 106" stroke={INK} strokeWidth="3" strokeLinecap="round" />
        <path d="M70 26 C72 22 76 22 78 25" stroke={INK} strokeWidth="3" strokeLinecap="round" />
    </svg>
);
